// @flow
import React from 'react';
import RenderFiltersHomes from '../../homes/component';
import RenderFiltersCars from '../../cars/component';
import RenderFiltersJobs from '../../jobs/component';
import RenderFiltersProducts from '../../products/component';

type Props = {
  verticalName: string,
};

const FiltersFromVertical = (props: Props) => {
  let Filters;
  const { verticalName } = props;
  switch (props.verticalName) {
    case 'homes':
      Filters = RenderFiltersHomes;
      break;
    case 'cars':
      Filters = RenderFiltersCars;
      break;
    case 'jobs':
      Filters = RenderFiltersJobs;
      break;
    case 'products':
      Filters = RenderFiltersProducts;
      break;
    default:
      return null;
  }
  const propsFilters = {
    ...props,
    verticalName,
  };
  return <Filters {...propsFilters} />;
};

export default FiltersFromVertical;



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/FiltersFromVertical/component.js